module.exports = __webpack_public_path__ + "static/media/team-rocket-2.12a44f60.wav";